import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { getBaseUrl } from '@/redux/modules/config';
import { useAppSelector } from '@/redux/hooks';
import { useLocation } from 'react-router';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import PageTitle from '@/components/PageTitle/PageTitle';
import styled from 'styled-components';

const NotFound = () => {
    const baseUrl = useAppSelector(getBaseUrl);
    const { pathname } = useLocation();
    return (
        <StyledNotFound>
            <StyledPageTitle title="404" />
            <StyledFirstP>
                <FormattedMessage id="sorry_we_cant_find" />
            </StyledFirstP>
            {Boolean(pathname) && (
                <p>
                    <StyledI>
                        &quot;
                        {`${baseUrl}${pathname}`}
                        &quot;
                    </StyledI>
                </p>
            )}
            <Link to={baseUrl}>www.liveauctioneers.com</Link>
        </StyledNotFound>
    );
};

export default NotFound;

const StyledNotFound = styled.div`
    margin: 60px 0;
    position: relative;
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const StyledPageTitle = styled(PageTitle)`
    text-align: center;
    font-size: 100px;
    line-height: 100px;
`;

const StyledFirstP = styled.p`
    margin-bottom: 0%;
`;

const StyledI = styled.i`
    color: ${({ theme }) => theme.colors.grey200};
`;
